import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=28317240&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=28317240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28317240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28317240')) {
      api.createRecord('28317240', component.options)
    } else {
      api.reload('28317240', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=28317240&scoped=true&", function () {
      api.rerender('28317240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/Breadcrumbs.vue"
export default component.exports